import { forwardRef, type Ref, type SVGProps } from "react";
const IconTourDoorFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m18 1 11 2.6c.6.1 1 .7 1 1.2v22c0 .5-.5 1.1-1 1.2l-11 2.6h-.2c-.5 0-.8-.3-.8-.8V17.367c-.363.093-.76.063-1.122-.114l-1.184-.626a3.13 3.13 0 0 1-1.63-1.878l-.266-.807-.909 3.483 2.36 2.513c.328.425.572.908.72 1.424l1.175 4.478a1.605 1.605 0 0 1-1.175 1.965 1.63 1.63 0 0 1-1.99-1.158l-.91-3.672a2.7 2.7 0 0 0-.72-1.432l-3.08-3.312a3.15 3.15 0 0 1-.72-2.95l.814-3.037L7 12.776c-.353.17-.64.454-.814.806l-.36.712a1.62 1.62 0 0 1-2.154.72c-.798-.428-.926-1.192-.712-2.144l.275-.72a4.9 4.9 0 0 1 2.53-2.325q.386-.147.732-.282c1.48-.573 2.507-.97 4.072-.97h.112a2.57 2.57 0 0 1-.97-2 2.574 2.574 0 1 1 3.131 2.514 5.47 5.47 0 0 1 2.96 3.32l.454 1.432.745.397V1.8c0-.5.3-.8.8-.8zm3 14.8c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1" />
    <path d="M5.739 21.628a3.2 3.2 0 0 1-.721 1.073l-2.53 2.505a1.63 1.63 0 0 0 0 2.324 1.716 1.716 0 0 0 2.358 0l3.08-3.036a4.6 4.6 0 0 0 .72-1.081l.73-1.716a31 31 0 0 1-2.445-2.685c-.103.017-1.192 2.616-1.192 2.616" />
  </svg>
);
const ForwardRef = forwardRef(IconTourDoorFilledSVG);
ForwardRef.displayName = "IconTourDoorFilled";
export { ForwardRef as IconTourDoorFilled };
